module.exports = __webpack_public_path__ + "img/motor_no11.5603bd1d.jpg";